import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { MultiSelectFilter, type FilterGroup } from '@/shared/ui/filters/multi-select-filter';

interface OrganizationsFilterProps {
  organizationGroups: FilterGroup[];
  selectedOrganizations: string[];
  onOrganizationsChange: (organizations: string[]) => void;
  isLoading?: boolean;
}

export function OrganizationsFilter({
  organizationGroups,
  selectedOrganizations,
  onOrganizationsChange,
  isLoading = false
}: OrganizationsFilterProps) {
  const { t } = useTranslation();

  return (
    <MultiSelectFilter
      label={t('dashboard.organizations.label', 'Organizations')}
      placeholder={t('dashboard.organizations.placeholder', 'Select organizations...')}
      searchPlaceholder={t('dashboard.organizations.search', 'Search organizations...')}
      emptyText={t('dashboard.organizations.empty', 'No organizations found')}
      icon={Building2}
      groups={organizationGroups}
      selectedItems={selectedOrganizations}
      onItemsChange={onOrganizationsChange}
      isLoading={isLoading}
      showSelectAll={true}
      maxDisplayItems={2}
    />
  );
}
